export function removeHttp(inputSrc: any) {
  let src = inputSrc;
  if (!src) return src;

  if (typeof src === 'object' && src.backgroundImage) {
    src.backgroundImage = src.backgroundImage.replace('p.qpic.cn', 'puep.qpic.cn');
    src.backgroundImage = src.backgroundImage.replace(/^http(s?):/, '');
    return src;
  }
  src = src.replace('p.qpic.cn', 'puep.qpic.cn');

  return src.replace(/^http(s?):/, '');
}

export function replaceUrl(href: string) {
  if (!href) {
    return;
  }
  const { location, history } = window;
  const result = location.protocol + removeHttp(href);
  if (history.replaceState) {
    history.replaceState(null, document.title, result);
    location.replace('');
  } else {
    location.replace(result);
  }
}
